
import styles from './GraphShimmer.module.scss';

interface BarGraphProps {
  data?: number[];
  barColor?: string;

  animationDuration?: number;
}

export const BarGraphShimmer: React.FC<BarGraphProps> = ({
  data=[10,15,20,25,30,35,40,45],
  barColor = '#4361ee',
  animationDuration = 2
}) => {
 
  const maxValue = Math.max(...data);
  
  return (
    <div className={styles.barGraphContainer}>
      <div className={styles.barGraph}>

        <div className={styles.yAxis} style={{ backgroundColor: barColor }}></div>
        <div className={styles.xAxis} style={{ backgroundColor: barColor }}></div>
        {data.map((value, index) => {
          const heightPercentage = (value / maxValue) * 100;
          
          return (
            <div 
              key={index} 
              className={styles.barContainer}
              style={{
                animationDelay: `${index * 0.15}s`,
              }}
            >
              <div 
                className={`${styles.bar} ${styles.animate}`}
                style={{
                  height: `${heightPercentage}%`,
                  backgroundColor: barColor,
                  animationDuration: `${animationDuration}s`
                }}
              >
                <div className={styles.shimmer}></div>
              </div>
            </div>
          );
        })}
      
      </div>
    </div>
  );
};

